import { useUser } from "MVVM/Hooks/useUser";
import { ActivityFeedHome } from "./ActivityFeedHome";
import { LoggedOutHome } from "./LoggedOutHome";

const Homepage = () => {
  const { allstarUser } = useUser();
  return allstarUser.loggedIn ? <ActivityFeedHome /> : <LoggedOutHome />;
};

export default Homepage;
